<template>
  <section id="beforeAfter">

    <div class="row mb-4">
      <div class="col-12 col-lg-5" :class="{'bg--image': true, 'bg--image-san-diego': location === 'san-diego'}"></div>

      <div class="col-12 col-lg-7 masthead--content d-flex justify-content-end mb-5">
        <div class="wrapper">
          <h3>Let's see some</h3><br>
          <h2 class="mb-5">Before <span class="gold">&</span><br />Afters</h2>
        </div>
      </div>
    </div>

    <div class="box--wrapper">
      <div class="container">

        <before-after-slider :entries="getEntriesForSection" :section="section" />

        <div class="row d-flex justify-content-between">
          <div class="col-12 view-all--link d-flex justify-content-end">
            <a href="../before-afters" class="link link--basic">View Other Procedures <br class="d-block d-md-none"/>Before & Afters <i class="fa-regular fa-angles-right ms-3"></i></a>
          </div>
        </div>
        
        <!-- Before / After Modals -->
        <div v-for="patient in getEntriesForSection" :key="patient.image" id="beforeAfterModals">

          <before-after-modal :patient="patient" :section="section" />
          
        </div>
        <!-- Before / After Modals END -->
      </div>
    </div>

  </section>
</template>

<script>
    const sections = require('../sliders.json')
    export default {
        props: {
            section: {
                type: String,
                required: true
            },
            location: {
                type: String,
                default: ''
            }
        },
        setup() {
            return {
                sections,
            }
        },
        computed: {
            getEntriesForSection() {
                return sections.filter(section => section.type == this.section)[0]?.entries
            }
        }
    }
</script>